module.exports = __webpack_public_path__ + "img/try2.8a4437e2.png";